/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Authenticate
 */
export interface Authenticate {
  /**
   *
   */
  username?: string;
  /**
   *
   */
  password?: string;
}

/**
 * Check if a given object implements the Authenticate interface.
 */
export function instanceOfAuthenticate(value: object): value is Authenticate {
  return true;
}

export function AuthenticateFromJSON(json: any): Authenticate {
  return AuthenticateFromJSONTyped(json, false);
}

export function AuthenticateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Authenticate {
  if (json == null) {
    return json;
  }
  return {
    username: json["username"] == null ? undefined : json["username"],
    password: json["password"] == null ? undefined : json["password"],
  };
}

export function AuthenticateToJSON(json: any): Authenticate {
  return AuthenticateToJSONTyped(json, false);
}

export function AuthenticateToJSONTyped(
  value?: Authenticate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    username: value["username"],
    password: value["password"],
  };
}
